import React from 'react';
import FacebookButton from '../ui/FacebookButton';
import useResolver from '../hooks/useResolver';
import AccountStore, { SocialLoginProvider } from '../store/AccountStore';
import useToast from '../hooks/useToast';

export interface ConnectedFacebookLoginProps {}

const ConnectedFacebookLogin: React.FC<ConnectedFacebookLoginProps> = () => {
  const accountStore = useResolver(AccountStore);
  const toast = useToast();

  return (
    <FacebookButton
      onClick={() =>
        accountStore.socialLogin(SocialLoginProvider.GOOGLE).catch((e) =>
          toast({
            status: 'error',
            title: 'Sign in failed',
            description: e.message,
          }),
        )
      }
    />
  );
};

export default ConnectedFacebookLogin;
